import React from 'react';
import { Spinner, SpinnerSize, Pivot, PivotItem } from '@fluentui/react';
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../helpers/HelperMethods';
import MyTeams from "./MyTeams";

const MyTeamsTabs = ({ parentPivotKey, isLoadingOwnedTeams, isLoadingcoOwnedTeams, ownedTeams, coOwnedTeams, ownedTeamsPageNavi, coOwnedTeamsPageNavi, editCallback }) => {

    const defaultSelectedKey = getPivotItemKeyFromUrl('Owned', parentPivotKey);
    const spinner = <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />;

    return (
        <div style={{width: '100%'}}>
            <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl(parentPivotKey)}>
                <PivotItem itemKey='Owned' headerText='Administrated' itemCount={isLoadingOwnedTeams ? undefined : ownedTeams.totalCount}>
                    {
                        isLoadingOwnedTeams ? spinner
                        : 
                        <div style={pivotItemStyles}>
                            <MyTeams teams={ownedTeams.results} editCallback={editCallback} myTeamsType={'ownedTeams'}/>
                            {ownedTeamsPageNavi}
                        </div>
                    }
                </PivotItem>
                <PivotItem itemKey='CoOwned' headerText='Co-administrated' itemCount={isLoadingcoOwnedTeams ? undefined : coOwnedTeams.totalCount}>
                    {
                        isLoadingcoOwnedTeams ? spinner
                        : 
                        <div style={pivotItemStyles}>
                            <MyTeams teams={coOwnedTeams.results} editCallback={editCallback} myTeamsType={'coOwnedTeams'}/>
                            {coOwnedTeamsPageNavi}
                        </div>
                    }
                </PivotItem>
            </Pivot>
        </div>
    );

}

const pivotStyles = {
    root: {
        marginBottom: 20
    },
    linkContent: {
        fontSize: 16,
        flex: 'auto'
    }
}

const pivotItemStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    width: "100%"
}

export default MyTeamsTabs


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MyTeamsTabs.js